import { StandardTextFieldProps, TextField } from "@mui/material";
import { IconButtonDelete } from "components/iconButtons";
import { useState } from "react";

interface IProps extends Omit<StandardTextFieldProps, "InputProps"> {
    onClickDelete: () => void;
}

export const TextFieldIconDelete: React.FC<IProps> = (props) => {
    var { onClickDelete, ...rest } = props;
    const [focus, setFocus] = useState<boolean>(false);

    return (
        <TextField
            {...rest}
            onFocus={() => setFocus(true)}
            onBlur={() => {
                setTimeout(() => setFocus(false), 300);
            }}
            slotProps={{
                input: {
                     endAdornment: focus ? <IconButtonDelete  size="small" onClick={onClickDelete} />  : undefined    
                }
            }}  
        />
    );
};
